import { render, staticRenderFns } from "./OfferView.vue?vue&type=template&id=474ccc16&"
import script from "./OfferView.vue?vue&type=script&lang=js&"
export * from "./OfferView.vue?vue&type=script&lang=js&"
import style0 from "./OfferView.vue?vue&type=style&index=0&id=474ccc16&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports